import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import { FORGET_PASSWORD, RESET_FORGET_PASSWORD } from "./actionTypes"
import {
    userForgetPasswordSuccess,
    userForgetPasswordError,
    userResetForgetPassword,
    userResetForgetPasswordSuccess,
    userResetForgetPasswordError,
} from "./actions"

import {
    postForgotPwd,
    postResetPwd,
} from "../../../helpers/backend_helper"

//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* forgetUser({ payload: { user, history } }) {
    try {
        if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
            //   const response = yield call(postJwtForgetPwd, "/jwt-forget-pwd", {
            //     email: user.email,
            //   })
            //   if (response) {
            //     yield put(
            //       userForgetPasswordSuccess(
            //         "Reset link are sended to your mailbox, check there first"
            //       )
            //     )
            //   }
            // } else {
            //   const response = yield call(postFakeForgetPwd, "/fake-forget-pwd", {
            //     email: user.email,
            //   })
            //   if (response) {
            //     yield put(
            //       userForgetPasswordSuccess(
            //         "Reset link are sended to your mailbox, check there first"
            //       )
            //     )
            //   }
        }

        const response = yield call(
            postForgotPwd,
            { userIdentity: user.email }
        )
        if (response) {
            yield put(userForgetPasswordSuccess("Reset link are sent"))
        }
    } catch (error) {
        yield put(userForgetPasswordError(error))
    }
}

function* resetForgetPassword({ payload: { user, history } }) {
    try {
        const response = yield call(
            postResetPwd,
            {
                oldPassword: user.oldPassword,
                newPassword: user.newPassword,
            }
        )
        if (response) {
            yield put(
                userResetForgetPasswordSuccess(
                    "Password reset successfully, please login with new password"
                )
            )
            history.push("/logout")
        }
    } catch (error) {
        yield put(userResetForgetPasswordError(error))
    }
}

// export function* watchUserPasswordForget() {
//   yield takeEvery(FORGET_PASSWORD, forgetUser)
// }

function* forgetPasswordSaga() {
    yield takeEvery(FORGET_PASSWORD, forgetUser)
    yield takeEvery(RESET_FORGET_PASSWORD, resetForgetPassword)
}

export default forgetPasswordSaga
